import React from 'react';
import styled from 'styled-components';
import { useMediaQuery } from 'react-responsive';
import { isProUser } from '__utils/common-utils';
import Header, { HeaderProps } from 'components/header';
import { BreadcrumbItem } from 'components/breadcrumb/type';
import Breadcrumb from 'components/breadcrumb';
import BseInformation from 'components/bse-information';
import CopyrightInfomration from 'components/copyright-information';
import GlobalFooter from 'components/global-footer';

interface LayoutContProps {
    isMobile: boolean
}
const LayoutCont = styled.div<LayoutContProps>`
`;

const MobileLayout = styled.div<any>`
    padding-top: ${(props: any) => props?.hideTopPaddingMobile ?'': isProUser()? '90px' : '58px'};
    padding-bottom: 50px;
    height: auto;
    margin-bottom: 60px;
`;

const DesktopLayout = styled.div`
    padding: 0;
    // min-width: 1080px;
    width: 100%;
`;


const DesktopInnerCont = styled.div<any>`
    width: ${(props: any) => props.desktopWidth ? props.desktopWidth : "1080px"};
    margin: 30px auto;
    min-height: 600px;
`;
/* const DesktopInnerCont = styled.div<IsFlowTypeProfileProp>`
    // width: 90vw;
    margin: 30px auto;
`;

const WhiteCardWrapper = styled.div`
    // background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 ${COLOR.SHADOWGREY};
    margin-bottom: 30px;
`; */

export interface LayoutProps {
    config?: HeaderProps;
    hideTopPaddingMobile?: boolean;
    children?: any;
    breadcrumbList?: BreadcrumbItem[];
    showBseInfoForDesktop?: boolean;
    showBseInfoForMobile?: boolean;
    showCopyrightInfoForDesktop?: boolean;
    showCopyrightInfoForMobile?: boolean;
    showGlobalFooter?: boolean;
    desktopWidth?: string;
}

const Layout: React.FC<LayoutProps> = (props: LayoutProps) => {

    const isMobile = useMediaQuery({ maxWidth: 767 });
    return (<LayoutCont isMobile={ isMobile }>
        {isMobile ? <MobileLayout hideTopPaddingMobile={props?.hideTopPaddingMobile}>
            <Header { ...props.config } />
            { props.children }            
            { props?.showBseInfoForMobile && <BseInformation /> }
            { props?.showCopyrightInfoForMobile && <CopyrightInfomration isMobile={ isMobile } /> }
            { props?.showGlobalFooter && <GlobalFooter/>}

        </MobileLayout> :
        <>
            <DesktopLayout>
                <Header { ...props.config } />
                <DesktopInnerCont desktopWidth={props.desktopWidth}>
                    { props.breadcrumbList && props.breadcrumbList?.length > 0 ? <Breadcrumb list={ props.breadcrumbList } /> : null }
                    <div>{ props.children }</div>
                    { props?.showBseInfoForDesktop && <BseInformation /> }
                </DesktopInnerCont>
                { props?.showCopyrightInfoForDesktop && <CopyrightInfomration /> }
            </DesktopLayout>
            { props?.showGlobalFooter && <GlobalFooter/>}
              
         </>}
    </LayoutCont>)
}

export default Layout;